import { render, staticRenderFns } from "./QuickLaunch.vue?vue&type=template&id=38dac8af&"
import script from "./QuickLaunch.vue?vue&type=script&lang=js&"
export * from "./QuickLaunch.vue?vue&type=script&lang=js&"
import style0 from "./QuickLaunch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuickLaunch.vue"
export default component.exports